module.exports = __webpack_public_path__ + "static/media/LOKnCHARGE_Black.90e19fcc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LOKnCHARGE_Black.png
// module id = 429
// module chunks = 0